import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export function QAStatus({ qaStatus }) {
  const qaStatusMap = {
    APPROVED: <FormattedMessage defaultMessage="Approved" id="6f806" />,
    AWAITING_QA: <FormattedMessage defaultMessage="Awaiting QA" id="a858f" />,
    DELETED: <FormattedMessage defaultMessage="Deleted" id="5fe60" />,
    FAILED_QA: <FormattedMessage defaultMessage="Failed QA" id="65992" />,
    UNKNOWN: <FormattedMessage defaultMessage="Unknown" id="88183" />,
  };
  return qaStatusMap[qaStatus] || qaStatusMap.UNKNOWN;
}

QAStatus.propTypes = {
  qaStatus: PropTypes.string.isRequired,
};

export default { QAStatus };
